import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Stick = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.32 80.8">
  <G fill={color}>
    <Path d="M26.82,45.06h-.41v-18.66c0-1.14-.72-2.11-1.72-2.5v-13.98C24.68,4.45,20.23,0,14.75,0S4.83,4.45,4.83,9.93v13.98c-1.01.39-1.72,1.36-1.72,2.5v18.66h-.41c-1.49,0-2.69,1.2-2.69,2.69v30.36c0,1.49,1.2,2.69,2.69,2.69h24.13c1.49,0,2.69-1.2,2.69-2.69v-30.36c0-1.49-1.2-2.69-2.69-2.69ZM10.2,9.93c0-2.51,2.04-4.55,4.55-4.55s4.55,2.04,4.55,4.55v13.79h-9.1v-13.79ZM19.42,49.02h-9.33c-1.49,0-2.69-1.2-2.69-2.69,0-.88.43-1.65,1.08-2.14.45-.34,1-.55,1.61-.55h9.33c.61,0,1.16.21,1.61.55.65.49,1.08,1.26,1.08,2.14,0,1.49-1.2,2.69-2.69,2.69Z"/>
    <Path d="M53.18,11.86h-11.24c-5.04,0-9.13,4.1-9.13,9.13v57.11c0,1.49,1.2,2.69,2.69,2.69h24.13c1.49,0,2.69-1.2,2.69-2.69V20.99c0-5.04-4.1-9.13-9.14-9.13Z"/>
  </G>
</Svg>
);
};

export default Stick;
